module.exports = __webpack_public_path__ + "static/media/pdf.cf26c845.svg";